/**
=========================================================
* Material Kit 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import { useRef } from 'react';
// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// react-flatpickr components
import Flatpickr from "react-flatpickr";

// react-flatpickr styles
import "flatpickr/dist/flatpickr.css";
import "flatpickr/dist/themes/material_blue.css"
import { French } from "flatpickr/dist/l10n/fr"
// Material Kit 2 React components
import MDInput from "dashboard/components/MDInput";
import InputAdornment from '@mui/material/InputAdornment';
import CancelIcon from '@mui/icons-material/Cancel';
import IconButton from '@mui/material/IconButton';

function MDDatePicker({ input, mode, ...rest }) {

  
  const refPicker = useRef();
  /* eslint-disable */
  const config = { 
    minDate: "1950-01-01", 
    altFormat: "F j, Y",
    dateFormat: "d M y",
    altInputClass: 'hide',
    locale : French,
    mode
  }
  const clearDate = () => {
    refPicker.current.flatpickr.clear()
  }
  return (
    <Flatpickr
      options={config}
      {...rest}
      render={({ defaultValue }, ref) => (
        <MDInput  {...input} defaultValue={defaultValue} inputRef={ref} 
        InputProps={{
          endAdornment : (
              <InputAdornment position="end">
                <IconButton
                  onClick={clearDate}
                  onMouseDown={clearDate}
                  edge="end"
                >
                  <CancelIcon />
                </IconButton>
              </InputAdornment>
          )
        }}
         />
      )}
      ref={refPicker}
    />
  );
}

// Setting default values for the props of MDDatePicker
MDDatePicker.defaultProps = {
  input: {},
};

// Typechecking props for the MDDatePicker
MDDatePicker.propTypes = {
  input: PropTypes.shape({}),
};

export default MDDatePicker;
